module.exports = __webpack_public_path__ + "id.svg?ff1f29216158fecf463ee7e990a89aa8";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/id.svg
// module id = 1083
// module chunks = 27